import { MASTER_PATH } from './masterPath';
import i18n from '../../../locales/i18n';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBreadSlice } from '@fortawesome/free-solid-svg-icons';
import { faShip } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';

export const masterBar = {
  subheader: i18n.t('sidemenu.master.title'),
  items: [
    { title: i18n.t('sidemenu.master.item'), path: MASTER_PATH.ITEM, icon: <FontAwesomeIcon icon={faBreadSlice} style={{ fontSize: '20px' }} /> },
    { title: i18n.t('sidemenu.master.ship'), path: MASTER_PATH.SHIP, icon: <FontAwesomeIcon icon={faShip} style={{ fontSize: '20px' }} /> },
    { title: i18n.t('sidemenu.master.mail'), path: MASTER_PATH.MAIL, icon: <FontAwesomeIcon icon={faEnvelope} style={{ fontSize: '20px' }} /> },
  ],
};
